module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-redo-daea83a0a40c9a809b74a6327f11c504.svg";